export default {
    getToken: function(){
        return getLocalstorage('token','');
    },
    log: function(...args) {
        console.log(args);
    },
    saveToken: function(webId,token) {
        setLocalstorage('webId',webId);
        setLocalstorage('token',token);
    },
    clearData: function() {
        clearLocalstorage();
    },
    unixTimeToDate(unixTime){
        let date = new Date(unixTime*1000);
        let day = date.getDay();
        let month = date.getMonth();
        let year = date.getFullYear();
        let hours = date.getHours();
        let minutes = "0" + date.getMinutes();
        let seconds = "0" + date.getSeconds();
        return day + '/' + month + '/' + year +' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    },
    saveLocalStorage(key, value){
        setLocalstorage(key, value);
    },
    loadLocalstorage(key,defaultVal){
        getLocalstorage(key,defaultVal)
    }
}

function clearLocalstorage() {
    localStorage.clear();
}

function setLocalstorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

function getLocalstorage(key,defaultVal) {
    if ( localStorage.getItem(key) !== null && localStorage.getItem(key) !== undefined ) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }catch{
            return defaultVal;
        }
    }else{
        return defaultVal;
    }
}
